import React from 'react';

import * as S from './styles';

function FormSectionCard({ title, subTitle, isLine = false, onClickButton, children }) {
  return (
    <S.CardContainer>
      <S.HeaderWrapper>
        <S.TitleWrapper>
          <S.CardTitle>{title}</S.CardTitle>
          <S.CardSubTitle>{subTitle}</S.CardSubTitle>
        </S.TitleWrapper>

        {onClickButton && (
          <S.AddButton type="button" onClick={onClickButton}>
            <i
              className="material-icons"
              style={{
                fontSize: '28px',
                color: localStorage.getItem('tema') == 'E' ? '#ffffff' : '#6796cf',
              }}
            >
              add
            </i>
          </S.AddButton>
        )}
      </S.HeaderWrapper>

      {isLine && <S.Line />}
      {children}
    </S.CardContainer>
  );
}

export default FormSectionCard;
